import React from 'react';
import { ButtonCard } from '@amzn/stencil-react-components/card';
import { Col, Row } from '@amzn/stencil-react-components/layout';
import { Text } from '@amzn/stencil-react-components/text';
import { Spinner } from '@amzn/stencil-react-components/spinner';
import { Chip, ChipBackgroundColor, ChipSize } from '@amzn/stencil-react-components/chip';

interface DashboardCardProps {
  title: string;
  description?: string;
  chip?: string;
  count: number;
  isActive: boolean;
  onClick: () => void;
  isLoading?: boolean;
}

const DashboardCard: React.FC<DashboardCardProps> = ({
  title,
  description,
  chip,
  count,
  isActive,
  onClick,
  isLoading,
}) => {
  const buttonCardStyle = {
    width: '100%',
    height: '100%',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: 'neutral05',
    },
  };
  const titleId = title.replace(/\s+/g, '-');

  return (
    <ButtonCard
      onClick={onClick}
      aria-pressed={isActive}
      backgroundColor={isActive ? 'neutral05' : undefined}
      css={buttonCardStyle}
      aria-describedby={`card-${titleId}-count card-${titleId}-description`}
    >
      <Col width="100%" gridGap="S200">
        <Row justifyContent="right" height="S500">
          {chip && (
            <Chip
              id={`card-${titleId}-chip`}
              size={ChipSize.ExtraSmall}
              backgroundColor={ChipBackgroundColor.Red}
              aria-hidden={true}
            >
              {chip}
            </Chip>
          )}
        </Row>
        <Row alignItems="center" justifyContent="center">
          <Text fontSize="T400" fontWeight="medium">
            {title}
          </Text>
        </Row>
        {description && (
          <Row justifyContent="center">
            <Text
              id={`card-${titleId}-description`}
              fontSize="T100"
              fontWeight="light"
              style={{ whiteSpace: 'normal' }}
              aria-hidden={true}
            >
              {description}
            </Text>
          </Row>
        )}
        <Row alignItems="center" justifyContent="center" padding="S300">
          {isLoading ? (
            <Spinner />
          ) : (
            <Text id={`card-${titleId}-count`} fontSize="T600" textAlign="center" aria-hidden={true}>
              {count !== null ? count : '0'}
            </Text>
          )}
        </Row>
      </Col>
    </ButtonCard>
  );
};

export default DashboardCard;
